export const blockIconsCommunicationComment = (
	<span className='material-symbols-outlined'>comment</span>
);
